import { render } from "./Paggination.vue?vue&type=template&id=5dce09c8&scoped=true"
import script from "./Paggination.vue?vue&type=script&lang=js"
export * from "./Paggination.vue?vue&type=script&lang=js"

import "./Paggination.vue?vue&type=style&index=0&id=5dce09c8&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5dce09c8"]])

export default __exports__